import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import "react-toastify/dist/ReactToastify.css";
import "./Signin.css";
import { baseUrl } from "../environment";
import BackButton from "../Shared/CommonComponent/BackButton";

export default function AuthForm() {
  const [isSignIn, setIsSignIn] = useState(true); // Toggle between Sign In and Sign Up
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState(""); // For Sign Up
  const [showFullSignUpForm, setShowFullSignUpForm] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleSignIn = async (e) => {
    e.preventDefault();
    const payload = { username: email, password };
  
    // if (email === 'Demo123' && password === 'demo@123') {
      const url = `${baseUrl}Auth/login`;

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
          mode: "cors", // Allow CORS requests
        });
  
        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
  
        const data = await response.json();
  
        if (data?.status === 200) {
          toast.success("Login Successful!", { position: "top-right", autoClose: 5000 });
          localStorage.setItem("Token", JSON.stringify(data?.token));
          const decode = jwtDecode(data.token);
          localStorage.setItem("UserInfo", btoa(JSON.stringify({ UserName: decode.UserName, Role: decode.Role })));
          navigate("/dashboard");
        } else {
          toast.error(data?.message || "Login failed.", { position: "top-right", autoClose: 5000 });
        }
        // We add this functionality due to api is not working
        // toast.success("Login Successful!", { position: "top-right", autoClose: 5000 });
        // localStorage.setItem("Token", tokenA);
        // const decode = jwtDecode(tokenA);
        // localStorage.setItem("UserInfo", btoa(JSON.stringify({ UserName: decode.UserName, Role: decode.Role })));
        // navigate("/dashboard");

      } catch (error) {
        console.error("Error during sign-in:", error);
        toast.error("Unable to connect to the server. Please try again.", { position: "top-right", autoClose: 5000 });
      }
    // } else {
      // toast.warning("Please fill out all fields before proceeding.", { position: "top-right", autoClose: 5000 });
    //   toast.warning("Wrong Username or Password.", { position: "top-right", autoClose: 5000 });
    // }
  };
  
  const handleSignUp = (e) => {
    e.preventDefault();
    toast.dark(
      "We’re not accepting new registrations at this time. To request access, please email us at info.contractassist@gmail.com",
      {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      }
    );
  };


  const handleProceedWithEmail = () => {
    if (email.trim()) {
      setShowFullSignUpForm(true);
    } else {
      toast.warning("Please enter a valid email to proceed.", {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };

  return (
    <>
    <BackButton />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="main-cont">
        <div className="form-container">
          <form className="auth-form" onSubmit={isSignIn ? handleSignIn : handleSignUp}>
            <div className="form-logo">
              {/* Add your logo here */}
              <img src="contract.png" alt="Logo" />
            </div>
            <h2>{isSignIn ? "Sign In" : "Sign Up"}</h2>
            <input
              type="text"
              placeholder="Username/Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {!isSignIn && (
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            )}
            {isSignIn && (
              <div className="form-actions">
                <Link to="/login" className="forgot-password-link">
                  Forgot password?
                </Link>
              </div>
            )}
            <button type="submit" className="auth-button">
              {isSignIn ? "Sign In" : "Sign Up"}
            </button>
            <p className="form-footer">
              {isSignIn
                ? "By signing in, you agree to our "
                : "By signing up, you agree to our "}
              <Link to="/login">General Terms & Conditions</Link> and our{" "}
              <Link to="/login">Privacy Policy</Link>.
            </p>
            <p className="toggle-form-link">
              {isSignIn ? (
                <>
                  Don't have an account?{" "}
                  {/* <span onClick={() => setIsSignIn(false)}>Create a new account</span>. */}
                  <span><Link to="/get-demo">Request a Demo</Link></span>
                </>
              ) : (
                <>
                  Already have an account?{" "}
                  <span onClick={() => setIsSignIn(true)}>Sign In</span>.
                </>
              )}
            </p>
          </form>
        </div>
      </div>
    </>
  );
}
